import { useAuthResult } from "./lib/auth/hooks/useAuthResult";

export const useIsAuthenticated = () => {
  const { user } = useAuthResult();
  return !!user;
};
